// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
/* eslint-disable camelcase */
import { createAsyncAction } from 'typesafe-actions';
import { Note } from '../../../types/Model';

// Update OnlineCourse Note
export interface UpdateOnlineCourseNoteRequestPayload {
  id: number;
  noteId: string;
  message: string;
}

export interface UpdateOnlineCourseNoteSuccessPayload {
  id: number;
  notes: Note[];
}

export interface UpdateOnlineCourseNoteFailPayload {
  error: Error;
}

const updateOnlineCourseNoteActions = createAsyncAction(
  'elearning/UPDATE_ONLINE_COURSE_NOTE_REQUEST',
  'elearning/UPDATE_ONLINE_COURSE_NOTE_SUCCESS',
  'elearning/UPDATE_ONLINE_COURSE_NOTE_FAIL'
)<UpdateOnlineCourseNoteRequestPayload, UpdateOnlineCourseNoteSuccessPayload, UpdateOnlineCourseNoteFailPayload>();

export { updateOnlineCourseNoteActions as default};
